(function () {
  var modal = document.getElementById('KhCleanSearch');
  var input = document.getElementById('KhCleanSearchInput');
  var activeTrigger = null;

  if (!modal) return;

  function setTriggersExpanded(value) {
    document.querySelectorAll('[data-kh-search-open]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', value ? 'true' : 'false');
    });
  }

  function openSearch(trigger) {
    activeTrigger = trigger || document.activeElement;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('kh-clean-search-open');
    setTriggersExpanded(true);

    window.setTimeout(function () {
      if (input) input.focus();
    }, 40);
  }

  function closeSearch() {
    if (modal.hidden) return;

    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('kh-clean-search-open');
    setTriggersExpanded(false);

    if (activeTrigger && typeof activeTrigger.focus === 'function') {
      activeTrigger.focus();
    }
    activeTrigger = null;
  }

  document.addEventListener('click', function (event) {
    var openTrigger = event.target.closest('[data-kh-search-open]');
    if (openTrigger) {
      event.preventDefault();
      openSearch(openTrigger);
      return;
    }

    if (event.target.closest('[data-kh-search-close]')) {
      event.preventDefault();
      closeSearch();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !modal.hidden) {
      closeSearch();
    }
  });
})();
